import * as Animate from "react-reveal";
import MicrosoftLogo from "../../../assets/images/png/partner-logo/ms_logo.webp";
import HpLogo from "../../../assets/images/png/partner-logo/hp.png";
import FacebookLogo from "../../../assets/images/png/partner-logo/facebook.webp";
import AmazonLogo from "../../../assets/images/png/partner-logo/amazon.webp";
import JicaLogo from "../../../assets/images/png/partner-logo/jica.webp";

const logos = [
  { src: MicrosoftLogo, alt: "Microsoft" },
  { src: HpLogo, alt: "HP" },
  { src: FacebookLogo, alt: "Facebook" },
  { src: AmazonLogo, alt: "Amazon" },
  { src: JicaLogo, alt: "JICA" },
];

const PayEcosystemSection = () => {
  return (
    <section
      aria-label="Organizations across the Utiva ecosystem"
      className="bg-white border-y border-[#dce3f1] px-6 lg:px-8"
    >
      <Animate.Fade bottom>
        <div className="container mx-auto flex flex-col md:flex-row md:items-center gap-[18px] md:gap-[30px] py-[27px]">
          <p
            className="text-primary tracking-[0.1em] uppercase text-[15px] font-black m-0 shrink-0"
            style={{ width: "220px" }}
          >
            The Utiva Ecosystem
          </p>
          <div className="flex justify-start md:justify-between items-center gap-[35px] overflow-x-auto">
            {logos.map((logo) => (
              <img
                key={logo.alt}
                src={logo.src}
                alt={logo.alt}
                className="object-contain grayscale opacity-[0.74] shrink-0"
                style={{ maxWidth: "140px", height: "45px" }}
              />
            ))}
          </div>
        </div>
      </Animate.Fade>
    </section>
  );
};

export default PayEcosystemSection;
